import { React, useState } from '@digsup/core-ui';
import PropTypes from 'prop-types';

export const Trigger = ({ children, className }) => {
  const [active, setActive] = useState(false);

  return (
    <span
      className={className}
      onTouchStart={() => setActive(true)}
      onTouchEnd={() => setActive(false)}
      onMouseOver={() => setActive(true)}
      onMouseLeave={() => setActive(false)}>
      {children({ active })}
    </span>
  );
};

Trigger.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
};

Trigger.defaultProps = {
  className: '',
};
